export const TableRowTypes = {
  Region: "region",
  RegionPrice: "region-price",
  GenGroup: "gen-group",
  Portfolio: "portfolio",
  Fuel: "fuel"
};
